module.exports = __webpack_public_path__ + "img/s4-1-ja.b0a5e5b5.jpg";